import { useTranslation } from "react-i18next";
import { Switch } from "@entur/form";

import { useSupportPreview } from "@app/AppProvider.tsx";

export function SupportPreviewToggle() {
  const { t } = useTranslation();
  const { canPreview, previewing, setPreviewing } = useSupportPreview();

  if (!canPreview) return null;

  return (
    <Switch checked={previewing} onChange={(e) => setPreviewing(e.target.checked)}>
      {t("support-preview.enter")}
    </Switch>
  );
}
